<template>
  <nav
    :class="{'side-menu--opened': menuOpened }"
    class="side-menu"
  >
    <div
      v-show="menuOpened"
      class="side-menu__overlay"
      @click.stop="$emit('close')"
    />
    <div class="side-menu-content">
      <div class="side-menu-version">
        <span>{{ `v. ${appVersion}` }}</span>
        <span
          v-if="envLabel"
          class="side-menu-env"
        >{{ envLabel }}</span>
      </div>
      <div class="side-menu-logo">
        <img :src="logo">
      </div>
      <div class="is-flex justify-center has-margin-bottom-5">
        <span
          v-if="user"
          class="user-title is-uppercase has-text-weight-medium is-size-12"
        >
          {{ user?.profile.desusr }} - {{ user?.profile.grpusr }}
        </span>
      </div>
      <ul class="has-margin-bottom-2">
        <li
          v-for="(menuItem, index) in sideMenu"
          :key="index"
        >
          <div
            v-if="menuItem.separator"
            class="menu-separator"
          >
            <span class="is-uppercase has-text-weight-medium is-size-10">
              {{ menuItem.label }}
            </span>
          </div>
          <SideMenuItem
            v-else
            :route-name="menuItem.route"
            :route-params="menuItem.routeParams"
            :label="menuItem.label"
            :icon="menuItem.icon"
            :name="menuItem.name"
            @click="goToSection(menuItem)"
          />
        </li>
      </ul>
    </div>
    <div class="refresh-menu">
      <IconButton
        rotate
        background="transparent"
        color="#346889"
        icon="reload"
        @click="$emit('reload')"
      />
    </div>
  </nav>
</template>

<script>

import { mapState, mapActions } from 'pinia';
import { useRootStore } from '@/stores/root';
import IconButton from '@/components/buttons/IconButton.vue';
import { useAppBreakpoints } from '@/composables/useBreakpoints';
import SideMenuItem from './SideMenuItem.vue';


export default {
  name: 'SideMenu',
  components: {
    SideMenuItem,
    IconButton,
  },
  props: {
    visible: { type: Boolean, default: false },
    logo: { type: String, required: true },
  },
  emits: ['close', 'reload', 'action'],
  // vue-mq ($mq) → useAppBreakpoints (isDesktop reattivo).
  setup() {
    const { isDesktop } = useAppBreakpoints();
    return { isDesktop };
  },
  computed: {
    // Vuex mapGetters → Pinia rootStore.
    ...mapState(useRootStore, ['sideMenu', 'user', 'menuOpened', 'appVersion']),
    // Label ambiente: build staging → "navigatest", build production → nessuna.
    envLabel() {
      return import.meta.env.MODE === 'staging' ? 'navigatest' : '';
    },
  },
  methods: {
    ...mapActions(useRootStore, ['setSectionCode']),
    goToSection(menuItem) {
      if (menuItem.action) this.$emit('action', menuItem.action);
      else this.setSectionCode(menuItem.code);
      // ex: !['desktop','widescreen','fullhd'].includes($mq) → !isDesktop.
      if (!this.isDesktop) this.$emit('close');
    },
  },
};
</script>

<style lang="scss">

.side-menu {
  transition: transform .33s ease-in-out;
  height: 100vh;
  top: 0px;
  width: 260px;
  background-color: $dark-primary;
  transform: translateX(-100%);
  position: fixed;
  z-index: 35;
  &--opened {
    transform: translateX(0);
  }
  &__overlay {
    @include until($desktop){
      background-color: $overlay-background-color;
      overflow: hidden;
      z-index: 30;
      position: fixed;
      bottom: 0;
      left: 260px;
      right: 0;
      top: 0;
      width: 100vw;
      cursor: pointer;
    }
  }
  .refresh-menu {
    position: fixed;
    bottom: 0px;
    width: 90%;
    background: $dark-primary;
    .icon {
      margin-bottom: 5px;
      margin-left: 5px;
    }
  }
}


.side-menu-content {
  position: relative;
  overflow: auto;
  background-color: $dark-primary;
  width: 260px;
  height: 100%;
  padding-bottom: 2rem;

  .side-menu-version {
    display: flex;
    flex-direction: column;
    color: #8DB6D0;
    font-size: $size-12;
    font-weight: $weight-bold;
    margin-top: 6px;
    margin-left: 12px;

    .side-menu-env {
      text-transform: uppercase;
      font-size: $size-12;
      color: #F5A623;
      letter-spacing: 0.5px;
    }
  }

  .side-menu-logo {
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    margin-bottom: 1rem;
    align-items: center;
    img {
      width: 140px;
    }
  }

  .user-title {
    color: $blue-calypso;
  }
  .menu-separator{
    color: $blue-calypso;
    padding: 2px 1.2rem;
  }
}

</style>
